var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from 'react-query';
import { fetchOauthProviders } from '../utils/api/oauthApi';
import { getQueryParamByName } from '../utils/urlDecoder';
/**
 * Defines which order the providers should be presented in.
 * */
var PROVIDERS_BY_ORDER = [
    {
        key: 'facebook',
        label: 'Facebook',
    },
    {
        key: 'google',
        label: 'Google',
    },
    {
        key: 'feide',
        label: 'Feide',
    },
];
var getProvidersInOrder = function (providers) { return PROVIDERS_BY_ORDER
    .filter(function (provider) { return !!providers && (provider.key in providers); })
    .map(function (provider) { return (__assign(__assign({}, provider), { url: providers[provider.key] })); }); };
export var getOauthRedirectUrl = function () {
    var origin = window.location.origin;
    var redirect = getQueryParamByName('redirect');
    if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) {
        return origin + "/oauth";
    }
    return origin + "/oauth?redirect=" + encodeURIComponent(redirect);
};
/**
 * Retrieves the list of OAuth 2.0 providers available on iBok.
 * Each provider is sorted in a specific order.
 * */
var useListOauthProviders = function () {
    var refetchIntervalMs = 900000; // Around 15 minutes
    var _a = useQuery('oauthProviders', function () { return fetchOauthProviders(getOauthRedirectUrl()); }, {
        refetchInterval: refetchIntervalMs,
        // Not really any special reason we use refetchIntervalMs for both options
        staleTime: refetchIntervalMs,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return {
        providers: getProvidersInOrder(data),
        error: error !== null && error !== void 0 ? error : undefined,
        isLoading: isLoading,
    };
};
export default useListOauthProviders;
